import { render, staticRenderFns } from "./OrganismConfigurationTemplate.vue?vue&type=template&id=0f4b3320&scoped=true&"
import script from "./OrganismConfigurationTemplate.vue?vue&type=script&lang=js&"
export * from "./OrganismConfigurationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OrganismConfigurationTemplate.vue?vue&type=style&index=0&id=0f4b3320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b3320",
  null
  
)

export default component.exports